import {
  removeSetting,
  retrieveSetting,
  storeSetting,
  storeToken
} from 'src/Common/common';
import { useSignInMutation } from 'src/redux/services/userApi';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import notification from '../../../components/Notification';

export interface FormFields {
  USERNAME: string;
  USERPWD: string;
  REMEMBER: boolean;
}

const validationSchema = yup.object({
  USERNAME: yup
    .string()
    .required('User Name is required')
    .max(25, 'User Name should be of maximum 25 characters length'),
  USERPWD: yup
    .string()
    .required('Password is required')
    .min(2, 'Password must between 2 and 8 Characters')
    .max(8, 'Password must between 2 and 8 Characters')
});

const FormManagement = () => {
  const [signIn, { isLoading }] = useSignInMutation();
  let initialValues: FormFields = {
    USERNAME: '',
    USERPWD: '',
    REMEMBER: false
  };
  if (retrieveSetting('username')) {
    initialValues = {
      USERNAME: retrieveSetting('username'),
      USERPWD: retrieveSetting('pwd'),
      REMEMBER: retrieveSetting('username') ? true : false
    };
  }

  const { control, handleSubmit } = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema)
  });

  const onSubmit = (values: any) => {
    signIn(values)
      .then((res: any) => {
        if (res.data && res.data.TOKEN) {
          storeToken(res.data.TOKEN);

          if (values.REMEMBER) {
            storeSetting('username', values.USERNAME);
            storeSetting('pwd', values.USERPWD);
          } else {
            removeSetting('username');
            removeSetting('pwd');
          }
        } else {
          if (!values.remember) {
            removeSetting('username');
            removeSetting('pwd');
          }
        }
      })
      .catch((e) => {
        if (!values.remember) {
          removeSetting('username');
          removeSetting('pwd');
        }

        notification.error({
          title: 'Error',
          message: e
        });
      });
  };

  return {
    isLoading,
    control,
    handleSubmit,
    onSubmit
  };
};

export default FormManagement;
